import React from 'react';
import './auth.scss';

const NETWORKS = [
  { cls: 'mtn', name: 'MTN' },
  { cls: 'airtel', name: 'Airtel' },
  { cls: 'glo', name: 'Glo' },
  { cls: 'ninemobile', name: '9mobile' },
];

/** Two-column sign-in layout: what the portal is for on the left, the form on the right. */
const AuthLayout = ({ title, subtitle, children, footer }) => (
  <div className="au">
    <aside className="au-side">
      <div className="ed-brand">
        <span className="ed-brand__mark" aria-hidden="true">E</span>
        <span className="ed-brand__name">Eudor</span>
        <span className="ed-brand__sub">Aggregator</span>
      </div>
      <div className="au-side__body">
        <p className="au-side__lead">One connection to every Nigerian network.</p>
        <p className="au-side__by">Eudor Innovations Limited, licensed VAS aggregator</p>
        <ul className="au-side__points">
          <li>Onboard a service once and we prepare the pack for each network.</li>
          <li>Test subscriptions and notifications in the sandbox before you go live.</li>
          <li>See active subscribers, renewals and revenue per network, every day.</li>
        </ul>
      </div>
      <ul className="au-networks" aria-label="Networks">
        {NETWORKS.map((n) => (
          <li key={n.cls} className={`au-net au-net--${n.cls}`}>
            {n.name}
          </li>
        ))}
      </ul>
    </aside>
    <main className="au-main">
      <div className="au-card">
        <h1 className="au-title">{title}</h1>
        {subtitle && <p className="au-subtitle">{subtitle}</p>}
        {children}
        {footer && <div className="au-footer">{footer}</div>}
      </div>
    </main>
  </div>
);

export default AuthLayout;
